import React from 'react';
import { Box, useMediaQuery } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import { getPlannerMode } from 'redux/PlannerModeSlice';
import { HEADER_HEIGHT_V1 } from 'projectConstants';
import BuilderMode from 'pages/BuilderMode';
import BuilderModeRevamp from 'pages/BuilderModeRevamp';

import PlanPageUIRevamp from './PlanPageUIRevamp';
import { PLAN_PAGE_GRADIENT } from './PlanPageUIRevamp/planPageRevampUi';

export interface Properties {
  flags: any;
}

const PlanRevamp = ({ flags }: Properties) => {
  const [isLaptop]: any = useMediaQuery('(max-width: 1024px)');

  const plannerMode = useSelector(getPlannerMode);

  const showBuilderMode = plannerMode && !isLaptop;
  // The revamped plan page brings its own theme/background and renders full-bleed
  const isRevampVisible = !showBuilderMode;
  const isBuilderModeV1 = flags.builderModeUiRevamp;
  return (
    <Box
      height={`calc(100vh - ${!flags?.uiRevamp ? HEADER_HEIGHT_V1 : '0px'})`}
      bg={isRevampVisible ? PLAN_PAGE_GRADIENT : 'gradient.body'}
      padding={isRevampVisible ? 0 : isLaptop ? 4 : ''}
      overflow='hidden'
      display='flex'
      flexDirection='column'
    >
      {/* No `planPageUiRevamp` gate here on purpose. This module *is* the
          redesign — gating it meant an environment where the LD flag is unset
          or false rendered the legacy `PlanPageScenario` from inside a folder
          called PlanRevamp, which is how this route kept coming up as the old
          UI. The flag still guards the redesign in `pages/PlanPageDetailsOPZ`,
          the untouched original, so production behaviour is unchanged. */}
      {showBuilderMode ? (
        isBuilderModeV1 ? (
          <BuilderModeRevamp />
        ) : (
          <BuilderMode />
        )
      ) : (
        <PlanPageUIRevamp />
      )}
    </Box>
  );
};

export default withLDConsumer()(PlanRevamp);
